module.exports = __webpack_public_path__ + "fonts/Gibson-SemiBoldItalic.c7a54d50.woff";